import React, { useState } from "react";
import "./Contact.css";
import { Button, Input, Textarea, Select, Alert } from "../ui";

const Contact: React.FC = () => {
  const [email, setEmail]     = useState("");
  const [sujet, setSujet]     = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus]   = useState<"idle" | "success" | "error">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !sujet || !message) return;
    setLoading(true);
    setStatus("idle");
    try {
      const res = await fetch("/backend/contact_mail.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          sujet,
          message: `Message de ${email} :\n\n${message}`,
        }),
      });
      if (res.ok) {
        setStatus("success");
        setEmail(""); setSujet(""); setMessage("");
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-section__inner">
        <h2>Contact</h2>
        <p>Une question, une commande, une collaboration ? Écrivez-moi.</p>

        {status === "success" && <Alert type="success">Message envoyé avec succès !</Alert>}
        {status === "error"   && <Alert type="error">Erreur d'envoi. Réessayez plus tard.</Alert>}

        <form className="contact-form" onSubmit={handleSubmit}>
          <Input
            label="Votre email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="votre@email.fr"
            required
          />
          <Select
            label="Sujet"
            value={sujet}
            onChange={(e) => setSujet(e.target.value)}
            required
            options={[
              { value: "", label: "Choisir un sujet..." },
              { value: "Commande", label: "Une commande" },
              { value: "Rencontre", label: "Une rencontre" },
              { value: "Partenariat", label: "Un partenariat" },
              { value: "Autre", label: "Autre" },
            ]}
          />
          <Textarea
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Votre message..."
            required
          />
          <Button type="submit" variant="primary" size="lg" loading={loading}>
            Envoyer
          </Button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
